import { router } from '@inertiajs/react';
import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import type { EntranceStats } from '@/types';

interface EntranceSearchProps {
  eventSlug: string;
  currentSearch: string;
  stats: EntranceStats;
}

export function EntranceSearch({
  eventSlug,
  currentSearch,
  stats,
}: EntranceSearchProps) {
  const [search, setSearch] = useState(currentSearch);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (search !== currentSearch) {
        router.get(
          `/admin/${eventSlug}/entrance`,
          search ? { search } : {},
          { preserveState: true, preserveScroll: true },
        );
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [search, currentSearch, eventSlug]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-6 text-sm">
        <div>
          <span className="text-muted-foreground">Hackers: </span>
          <span className="font-semibold">{stats.totalHackers}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Onboarded: </span>
          <span className="font-semibold">
            {stats.onboardedHackers}/{stats.totalHackers}
          </span>
        </div>
        <div>
          <span className="text-muted-foreground">Mentors: </span>
          <span className="font-semibold">{stats.totalMentors}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Total: </span>
          <span className="font-semibold">{stats.totalPeople}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Entered: </span>
          <span className="font-semibold">
            {stats.totalEntered} ({stats.percentage}%)
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="relative flex-1">
          <Search className="-translate-y-1/2 absolute top-1/2 left-3 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search by name or email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-10"
          />
        </div>
      </div>
    </div>
  );
}
